import { configureStore } from "@reduxjs/toolkit";

import listsReducer from "./state/lists";
import armyReducer from "./state/army";
import itemsReducer from "./state/items";
import errorsReducer from "./state/errors";
import rulesIndexReducer from "./state/rules-index";
import settingsReducer from "./state/settings";
import loginReducer from "./state/login";
import battleReducer from "./state/battle";

const store = configureStore({
  reducer: {
    lists: listsReducer,
    army: armyReducer,
    items: itemsReducer,
    errors: errorsReducer,
    rulesIndex: rulesIndexReducer,
    settings: settingsReducer,
    login: loginReducer,
    battle: battleReducer,
  },
});

// Persist battle state so a reload mid-game loses nothing.
// Trailing-edge debounce: the final update in a burst always gets written.
let lastBattleState;
let persistTimeout = null;
store.subscribe(() => {
  const battleState = store.getState().battle;

  if (battleState === lastBattleState) return;
  lastBattleState = battleState;

  clearTimeout(persistTimeout);
  persistTimeout = setTimeout(() => {
    try {
      localStorage.setItem("owb.battle", JSON.stringify(battleState));
    } catch {}
  }, 250);
});

export default store;
